<template>
    <div class="navigation-tabs">
        <nav>
            <a @click.prevent="loadTab(index)" v-bind:class="{ active : index == isActive }" href=""
               v-for="(link,index) in links" v-html="link.title"></a>
        </nav>
        <div class="nav-container">
            <div class="loader" v-if="loading"></div>
            <div ref="container" class="content" v-bind:class="{ loading : loading }">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    module.exports = {
        created: function () {
            this.isActive = this.active;
        },
        data:function() {
            return {
                loading:false,
                isActive:false,
                currentTab:0,
                refreshing:false
            }
        },
        props:{
            links:{type:Array,default:function() { return [] }},
            active:{type:Number,default:0},
            refresh:{type:Number,default:0}
        },
        watch: {
            refresh: function() {
                this.refreshing = true;
                this.loadTab(this.currentTab);
            }
        },
        methods: {
            loadTab:function(index) {
                this.currentTab = index;
                this.isActive = index;
                var e = this;
                if(this.links[index].url != undefined) {
                    this.loading = this.refreshing ? false : true;
                    var url = this.links[index].url;
                    $.get(url, function (data) {
                        if (data.status == 200) {
                            $(e.$el).find('.content').html('<div id="nav-tab-content"></div>');
                            if (!e.refreshing) {
                                $(e.$el).find('.content').css('opacity', 0);
                            }
                            var res = Vue.compile(data.content);
                            var vm = new Vue({
                                el: '#nav-tab-content',
                                render: res.render,
                                staticRenderFns: res.staticRenderFns
                            });
                            e.loading = false;
                            $(e.$el).find('.content').animate({opacity: 1}, 500);
                            e.refreshing = false;
                        } else {
                            alert(data.msg);
                            e.refreshing = false;
                            e.loading = false;
                        }
                    });
                } else if(this.links[index].tab != undefined) {
                    $('.tab-link').hide();
                    $(this.links[index].tab).show();
                }
            }
        },
        mounted:function() {
        }
    }
</script>
